import { Injectable } from '@angular/core';
import { Cookies, LOCAL_STORAGE_KEYS } from '../../values.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root'
})

export class AuthService {

    constructor(
        private readonly cookieService: CookieService
    ) { }

    public getToken(): string {
        return this.cookieService.get(Cookies.TOKEN);
    }

    /**
     * Set the token and its expiry in local storage
     * @param token The authentication token
     * @param expiresIn Expiry duration in seconds
     */
    public setToken(token: string, expiresIn: number): void {
        const expiryDate = new Date(new Date().getTime() + (expiresIn * 1000));
        const exp = new Date(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate());
        // 2 min for test purpose -> expire token
        this.cookieService.set(Cookies.TOKEN, token, exp, '/', '', true, 'Strict');
    }

    public clearLoginInfo(): void {
        // Clear any stored user data
        localStorage.removeItem(LOCAL_STORAGE_KEYS.token);
        localStorage.clear();
        localStorage.clear();
        this.cookieService.deleteAll();
    }

    /**
     * Check if the user is logged in
     * @returns True if the user is logged in, false otherwise
     */
    public isLoggedIn(): boolean {
        const rsp = this.cookieService.get('_btoken');
        if (rsp || rsp !== '') {
            return true;
        } else {
            return false;
        }
    }
}
